import { ChevronRight } from '@griply/assets';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Icon } from 'shared/components/ui/icon';

import { ConfettiBurst } from './confetti-burst';
import { SetupChecklistCheckbox } from './setup-checklist-checkbox';
import * as Styled from './setup-checklist-row.style';

export type SetupChecklistRowProps = {
  label: string;
  complete: boolean;
  onNavigate?: () => void;
};

export const SetupChecklistRow: React.FC<SetupChecklistRowProps> = ({
  label,
  complete,
  onNavigate,
}) => {
  const [showConfetti, setShowConfetti] = useState(false);
  const previousComplete = useRef(complete);

  const onConfettiDone = useCallback(() => setShowConfetti(false), []);

  const checkbox = (
    <Styled.CheckWrapper>
      <SetupChecklistCheckbox checked={complete} />
      {showConfetti && <ConfettiBurst onDone={onConfettiDone} />}
    </Styled.CheckWrapper>
  );

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;

    if (complete && !previousComplete.current && !prefersReducedMotion) {
      setShowConfetti(true);
    }

    previousComplete.current = complete;
  }, [complete]);

  if (!complete && onNavigate) {
    return (
      <Styled.RowButton type="button" onClick={onNavigate}>
        {checkbox}
        <Styled.Label $complete={false}>{label}</Styled.Label>
        <Styled.Arrow>
          <Icon icon={ChevronRight} size={16} strokeWidth={2.5} />
        </Styled.Arrow>
      </Styled.RowButton>
    );
  }

  return (
    <Styled.Row>
      {checkbox}
      <Styled.Label $complete={complete}>{label}</Styled.Label>
    </Styled.Row>
  );
};
